import { render, staticRenderFns } from "./AVIChat.vue?vue&type=template&id=68c46cdf&scoped=true"
import script from "./AVIChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AVIChat.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AVIChat.vue?vue&type=style&index=0&id=68c46cdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c46cdf",
  null
  
)

export default component.exports